import MutateDeleteWetSignature from '../graphql/mutations/MutateDeleteWetSignature';
import MutateGetWetSignatureUrl from '../graphql/mutations/MutateGetWetSignatureUrl';
import MutateSendWetSignatureEmail from '../graphql/mutations/MutateSendWetSignatureEmail';

import { mapActions, mapGetters, mapState } from 'vuex';
import { GLOBAL_ERROR } from './../components/GlobalError/GlobalError';
import appConfig from '../utils/app-config';

export default {
  data: function () {
    return {
      loadingDocumentMLADownload: false,
      loadingDocumentPCADownload: false,
      loadingDocumentBankDownload: false,
      loadingDocumentQuoteDownload: false,
      loadingDocumentAllDownload: false,
      loadingDocumentMLASendEmail: false,
      loadingDocumentPCASendEmail: false,
      loadingDocumentBankSendEmail: false,
      loadingDocumentQuoteSendEmail: false,
      loadingDocumentSendAllSendEmail: false,
      loadingDocumentMLADelete: false,
      loadingDocumentPCADelete: false,
      loadingDocumentBankDelete: false,
      loadingDocumentQuoteDelete: false,
      loadingDocumentInstructionDownload: false,
      loadingDocumentInstructionSendEmail: false
    };
  },
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    ...mapGetters({
      whiteLabel: 'theme/getWhitelabel',
      isWetSignature: 'vehicleApplication/isWetSignature'
    }),
    isMilesNZ() {
      return this.region == 'NZ';
    },
    enableDisableWSMix() {
      if (
        this.loadingDocumentMLADownload ||
        this.loadingDocumentPCADownload ||
        this.loadingDocumentBankDownload ||
        this.loadingDocumentQuoteDownload ||
        this.loadingDocumentAllDownload ||
        this.loadingDocumentMLASendEmail ||
        this.loadingDocumentPCASendEmail ||
        this.loadingDocumentBankSendEmail ||
        this.loadingDocumentQuoteSendEmail ||
        this.loadingDocumentSendAllSendEmail ||
        this.loadingDocumentMLADelete ||
        this.loadingDocumentPCADelete ||
        this.loadingDocumentBankDelete ||
        this.loadingDocumentQuoteDelete ||
        this.loadingDocumentInstructionDownload ||
        this.loadingDocumentInstructionSendEmail
      )
        return true;
      else return false;
    },
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    }
  },
  methods: {
    ...mapActions({
      updateWetSignatureState: 'vehicleApplication/updateWetSignatureState'
    }),
    onClickDownloadWSMix: async function (wetSignatureObjName) {
      const isMilesNZ = this.isMilesNZ;

      if (wetSignatureObjName === 'documentMLA') this.loadingDocumentMLADownload = true;
      if (wetSignatureObjName === 'documentPCA') this.loadingDocumentPCADownload = true;
      if (wetSignatureObjName === 'documentBank') this.loadingDocumentBankDownload = true;
      if (wetSignatureObjName === 'documentQuote') this.loadingDocumentQuoteDownload = true;
      if (wetSignatureObjName === 'download-all') this.loadingDocumentAllDownload = true;
      if (wetSignatureObjName === 'documentAI' || wetSignatureObjName === 'documentAI_MMBA') {
        this.loadingDocumentInstructionDownload = true;
        await this.handleDownloadDocumentInstructions();
        this.loadingDocumentInstructionDownload = false;
        return;
      }
      await this.$apollo
        .mutate({
          mutation: MutateGetWetSignatureUrl,
          variables: {
            applicationId: this.vehicleApplication.applicationId,
            wetSignatureObjName: wetSignatureObjName
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
      setTimeout(async () => {
        await this.$apollo
          .mutate({
            mutation: MutateGetWetSignatureUrl,
            variables: {
              applicationId: this.vehicleApplication.applicationId,
              wetSignatureObjName: wetSignatureObjName
            }
          })
          .then((data) => {
            if (
              data &&
              data.data &&
              data.data.getWetSignatureUrl &&
              data.data.getWetSignatureUrl.files &&
              data.data.getWetSignatureUrl.files.length
            ) {
              let self = this;
              for (let ii = 0; ii < data.data.getWetSignatureUrl.files.length; ii++) {
                setTimeout(function () {
                  if (isMilesNZ && data.data.getWetSignatureUrl.files[ii].fileName !== 'documentQuote') {
                    self.downloadFileWSMix(
                      data.data.getWetSignatureUrl.files[ii].url,
                      self.generateFileNameWSMix(data.data.getWetSignatureUrl.files[ii].fileName)
                    );
                  } else if (!isMilesNZ) {
                    self.downloadFileWSMix(
                      data.data.getWetSignatureUrl.files[ii].url,
                      self.generateFileNameWSMix(data.data.getWetSignatureUrl.files[ii].fileName)
                    );
                  }

                  if (wetSignatureObjName === 'documentMLA') self.loadingDocumentMLADownload = false;
                  if (wetSignatureObjName === 'documentPCA') self.loadingDocumentPCADownload = false;
                  if (wetSignatureObjName === 'documentBank') self.loadingDocumentBankDownload = false;
                  if (wetSignatureObjName === 'documentQuote') self.loadingDocumentQuoteDownload = false;
                  if (wetSignatureObjName === 'download-all') self.loadingDocumentAllDownload = false;
                });
              }
              if (wetSignatureObjName === 'download-all' && self.isWetSignature) self.handleDownloadDocumentInstructions();
            }
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error);
          });
      });
    },
    handleDownloadDocumentInstructions: async function () {
      try {
        let url = `${appConfig.VUE_APP_IMAGE_ASSETS_URI}/AU_Agreement Instruction.pdf`;

        if (this.isMilesNZ) {
          url = `${appConfig.VUE_APP_IMAGE_ASSETS_URI}/NZ_Agreement Instruction.pdf`;
        } else if (this.isMMBA) {
          url = `${appConfig.VUE_APP_IMAGE_ASSETS_URI}/MDF_AU_Agreement Instruction.pdf`;
        }

        await new Promise((resolve, reject) => {
          this.downloadFileWSMix(url, 'Document-Instruction.pdf');

          window.addEventListener('unhandledrejection', (event) => {
            reject(event);
          });

          setTimeout(() => {
            resolve();
          }, 1000);
        });
      } catch (error) {
        this.$euiNotifications.emit({
          notification: GLOBAL_ERROR
        });
      }
    },
    onClickSendEmailWSMix: async function (wetSignatureObjName, email) {
      if (wetSignatureObjName === 'documentMLA') this.loadingDocumentMLASendEmail = true;
      if (wetSignatureObjName === 'documentPCA') this.loadingDocumentPCASendEmail = true;
      if (wetSignatureObjName === 'documentBank') this.loadingDocumentBankSendEmail = true;
      if (wetSignatureObjName === 'documentQuote') this.loadingDocumentQuoteSendEmail = true;
      if (wetSignatureObjName === 'documentAI' || wetSignatureObjName === 'documentAI_MMBA')
        this.loadingDocumentInstructionSendEmail = true;
      if (wetSignatureObjName === 'send-all') this.loadingDocumentSendAllSendEmail = true;
      await this.$apollo
        .mutate({
          mutation: MutateGetWetSignatureUrl,
          variables: {
            applicationId: this.vehicleApplication.applicationId,
            wetSignatureObjName: 'documentBank'
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
      setTimeout(async () => {
        await this.$apollo
          .mutate({
            mutation: MutateSendWetSignatureEmail,
            variables: {
              applicationId: this.vehicleApplication.applicationId,
              wetSignatureObjName: wetSignatureObjName,
              email: email
            }
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error);
          });
      });
      if (wetSignatureObjName === 'documentMLA') this.loadingDocumentMLASendEmail = false;
      if (wetSignatureObjName === 'documentPCA') this.loadingDocumentPCASendEmail = false;
      if (wetSignatureObjName === 'documentBank') this.loadingDocumentBankSendEmail = false;
      if (wetSignatureObjName === 'documentQuote') this.loadingDocumentQuoteSendEmail = false;
      if (wetSignatureObjName === 'documentAI' || wetSignatureObjName === 'documentAI_MMBA')
        this.loadingDocumentInstructionSendEmail = false;
      if (wetSignatureObjName === 'send-all') this.loadingDocumentSendAllSendEmail = false;
    },
    onClickDeleteWSMix: async function (wetSignatureObjName) {
      if (wetSignatureObjName === 'documentMLA') this.loadingDocumentMLADelete = true;
      if (wetSignatureObjName === 'documentPCA') this.loadingDocumentPCADelete = true;
      if (wetSignatureObjName === 'documentBank') this.loadingDocumentBankDelete = true;
      if (wetSignatureObjName === 'documentQuote') this.loadingDocumentQuoteDelete = true;
      await this.$apollo
        .mutate({
          mutation: MutateDeleteWetSignature,
          variables: {
            applicationId: this.vehicleApplication.applicationId,
            wetSignatureObjName: wetSignatureObjName
          }
        })
        .then((data) => {
          if (data && data.data && data.data.deleteWetSignature && data.data.deleteWetSignature.url) {
            let self = this;
            setTimeout(function () {
              self.updateWetSignatureState({
                uploadFile: null,
                wetSignatureObjName: wetSignatureObjName
              });
            });
          }
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      if (wetSignatureObjName === 'documentMLA') this.loadingDocumentMLADelete = false;
      if (wetSignatureObjName === 'documentPCA') this.loadingDocumentPCADelete = false;
      if (wetSignatureObjName === 'documentBank') this.loadingDocumentBankDelete = false;
      if (wetSignatureObjName === 'documentQuote') this.loadingDocumentQuoteDelete = false;
    },
    generateFileNameWSMix: function (wetSignatureObjName) {
      if (wetSignatureObjName === 'documentMLA')
        return this.region == 'NZ' ? 'Motor-Vehicle-Leasing-Terms-And-Conditions' : 'Master-Lease-Agreement.pdf';
      if (wetSignatureObjName === 'documentPCA') return this.region == 'NZ' ? 'Deed-of-Guarantee-And-Indemnity' : 'Personal-Guarantee.pdf';
      if (wetSignatureObjName === 'documentBank') return 'Direct-Debit.pdf';

      return 'Quote.pdf';
    },
    downloadFileWSMix2: function (link, fileName) {
      var url = link;
      var req = new XMLHttpRequest();
      req.open('GET', url, true);
      req.responseType = 'blob';
      req.onload = function () {
        var blob = new Blob([req.response], {
          type: 'application/octetstream'
        });
        var isIE = false || !!document.documentMode;
        if (isIE) {
          window.navigator.msSaveBlob(blob, fileName);
        } else {
          var url = window.URL || window.webkitURL;
          link = url.createObjectURL(blob);
          var a = document.createElement('a');
          a.setAttribute('download', fileName);
          a.setAttribute('href', link);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      };
      req.send();
    },
    downloadFileWSMix(url, filename) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        })
        .catch(
          // eslint-disable-next-line
          console.error
        );
    },
    onBlurWSMix: function () {
      this.validate = true;
      this.$refs.field.validate();
    },
    getRulesWSMix: function () {
      const rules = [];
      rules.push((val) => {
        if (!val || val == '') {
          return 'Field is required';
        }
        return true;
      });
      rules.push((val) => {
        if (this.validate && !this.validateEmailWSMix(val)) {
          return 'Field needs to be an email address';
        }
        return true;
      });
      return rules;
    },
    validateEmailWSMix: function (email) {
      const re =
        /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(String(email).toLowerCase());
    }
  }
};
